import { Button, ButtonGroup, ButtonGroupProps } from "@chakra-ui/react";
import useRouteSearchValue from "../hooks/use-route-search-value";

export type FeedSortMode = "recent" | "following" | "hot";

export default function FeedSortTabs(props: Omit<ButtonGroupProps, "children">) {
  const sortParam = useRouteSearchValue("sort", "recent");
  const mode = sortParam.value as FeedSortMode;

  return (
    <ButtonGroup size="sm" variant="outline" isAttached {...props}>
      <Button
        variant={mode === "recent" ? "solid" : "outline"}
        onClick={() => sortParam.setValue("recent")}
      >
        Recent
      </Button>
      <Button
        variant={mode === "following" ? "solid" : "outline"}
        onClick={() => sortParam.setValue("following")}
      >
        Following
      </Button>
      <Button
        variant={mode === "hot" ? "solid" : "outline"}
        onClick={() => sortParam.setValue("hot")}
      >
        Hot
      </Button>
    </ButtonGroup>
  );
}
